import React, { Fragment, PureComponent } from "react";
import "moment/locale/fr";
import _ from "lodash";
import { Divider, Dropdown, Form, Icon, Menu, Modal, Tooltip } from "antd";

import List from "components/list/List";
import Pagination from "components/pagination/Pagination";
import ImportModele from "./ImportModele";
import moment from "moment";
import Status from "components/status/Status.js";
import AuthRender from "../../AuthRender";
import { ACCESS, SERVICES } from "../../../configs/constants";

const { confirm } = Modal;
class ModelesList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sortOrder: 0
    };

    this.importForm = React.createRef();
  }
  componentDidMount() {
    this.props.init("models");
  }

  getColumns() {
    const { modelDelete } = this.props;
    //TODO refactor
    return [
      {
        title: "Nom",
        dataIndex: "client.assortmentLabel",
        key: "client.assortmentLabel",
        sortable: true,
        render: (text, record, index) => {
          return <div>{record.assortmentLabel}</div>;
        }
        // sorter: (a, b) => {
        //   if (!a || !b) return 0;
        //   console.log("a -------> ", a);
        //   console.log("b : ", b);
        //   return a.age - b.age;
        //   // return a.name.length - b.name.length;
        //   // return a["client.assortmentLabel"].localeCompare(b["client.assortmentLabel"]);
        // }
      },
      {
        title: "Statut",
        dataIndex: "active",
        key: "active",
        sortable: true,
        render: (text, record, index) => {
          const periodicity = record.periodicity || {};
          const startDate = moment(periodicity.startDate);
          const endDate = moment(periodicity.endDate);
          const now = moment();
          const isActive = startDate.isBefore(now) && endDate.isAfter(now);
          const statusId = isActive ? 2 : 3;

          return <Status statusId={statusId} />;
        }
      },
      {
        title: "Période",
        dataIndex: "periodicity",
        key: "periodicity",
        sortable: true,
        render: (text, record, index) => {
          return (
            <Fragment>
              {record.periodicity && (
                <div>
                  {moment(record.periodicity.startDate).format("DD/MM/YYYY")}
                  {` - `}
                  {moment(record.periodicity.endDate).format("DD/MM/YYYY")}
                </div>
              )}
            </Fragment>
          );
        }
      },
      {
        title: "Date de création",
        dataIndex: "created_at",
        key: "created_at",
        sortable: true,
        render: (text, record) => {
          return <div>{moment(record.created_at).format("DD/MM/YYYY")}</div>;
        }
      },
      {
        title: "Emplacement",
        dataIndex: "allLocationTypes",
        key: "allLocationTypes",
        render: (text, record, index) => {
          const locations = record.allLocationTypes;

          return (
            <Fragment>
              {!_.isEmpty(locations) && (
                <Dropdown
                  overlay={
                    <Menu>
                      {locations.map((location, index) => (
                        <Menu.Item key={index}>{location.label}</Menu.Item>
                      ))}
                    </Menu>
                  }
                >
                  <a className="ant-dropdown-link">{locations.length} emplacement(s)</a>
                </Dropdown>
              )}
            </Fragment>
          );
        }
        // sorter: {
        //   compare: (a, b) => a.english - b.english,
        //   multiple: 1
        // }
      },
      {
        title: "Enseigne",
        dataIndex: "client.retailer_label",
        key: "client.retailer_label",
        sortable: true,
        render: (text, record, index) => {
          return <div>{record.retailer_label}</div>;
        }
      },
      {
        title: "Marque",
        //a modifier
        dataIndex: "allProducts",
        key: "allProducts",
        render: (text, record, index) => {
          const products = record.allProducts;
          const allBrands = [];
          products.forEach(product => {
            if (!allBrands.includes(product.brand)) allBrands.push(product.brand);
          });
          return (
            <Fragment>
              {!_.isEmpty(products) && (
                <Dropdown
                  overlay={
                    <Menu>
                      {allBrands.map((brand, index) => (
                        <Menu.Item key={index}>{brand}</Menu.Item>
                      ))}
                    </Menu>
                  }
                >
                  <a className="ant-dropdown-link">{allBrands.length} marque(s)</a>
                </Dropdown>
              )}
            </Fragment>
          );
        }
      },
      {
        title: "Famille",
        //a modifier
        dataIndex: "allProducts",
        key: "allProducts",
        render: (text, record, index) => {
          const products = record.allProducts;
          const allFamilies = [];
          products.forEach(product => {
            if (!allFamilies.includes(product.family)) allFamilies.push(product.family);
          });
          return (
            <Fragment>
              {!_.isEmpty(products) && (
                <Dropdown
                  overlay={
                    <Menu>
                      {allFamilies.map((family, index) => (
                        <Menu.Item key={index}>{family}</Menu.Item>
                      ))}
                    </Menu>
                  }
                >
                  <a className="ant-dropdown-link">{allFamilies.length} famille(s)</a>
                </Dropdown>
              )}
            </Fragment>
          );
        }
      },
      {
        title: "Strate",
        dataIndex: "allRanges",
        key: "allRanges",
        render: (text, record) => {
          const ranges = record.allRanges;

          return (
            <Fragment>
              {!_.isEmpty(ranges) && (
                <Dropdown
                  overlay={
                    <Menu>
                      {ranges.map((range, index) => (
                        <Menu.Item key={index}>{range.label}</Menu.Item>
                      ))}
                    </Menu>
                  }
                >
                  <a className="ant-dropdown-link">{ranges.length} strate(s)</a>
                </Dropdown>
              )}
            </Fragment>
          );
        }
      },
      {
        title: "Actions",
        dataIndex: "actions",
        key: "actions",
        sortable: false,
        render: (text, record, index) => {
          return (
            <Fragment>
              <AuthRender service={SERVICES.Modele} access={[ACCESS.suppression]}>
                <Fragment>
                  <a
                    onClick={() => {
                      if (this.importForm) {
                        this.importForm.current.open(record);
                      }
                    }}
                  >
                    <Tooltip placement="top" title={"Modifier"}>
                      <Icon type="edit" style={{ fontSize: 14, color: "#000000" }} />
                    </Tooltip>
                  </a>
                  <Divider type="vertical" />
                </Fragment>
              </AuthRender>
              <AuthRender service={SERVICES.Modele} access={[ACCESS.suppression]}>
                <Fragment>
                  <a
                    onClick={() => {
                      confirm({
                        title: "Confirmation",
                        content: `Voulez-vous vraiment supprimer le modèle ${record.assortmentLabel} ?`,
                        onOk() {
                          modelDelete(record);
                        },
                        onCancel() {}
                      });
                    }}
                  >
                    <Tooltip placement="top" title={"Supprimer"}>
                      <Icon type="delete" style={{ fontSize: 14, color: "#000000" }} />
                    </Tooltip>
                  </a>
                </Fragment>
              </AuthRender>
            </Fragment>
          );
        }
      }
    ];
  }
  render() {
    const { modelsList, page, pages, pageSize, nbItems, getNext, modelsListLoading } = this.props;
    const columns = this.getColumns().map(column => {
      // if (column && column.sorter) console.log("column : ", column, column.sorter);
      let newColumn = {
        title: column.title,
        dataIndex: column.key,
        key: column.key
        // sorter: column.sorter,
        // sortDirections: ["descend", "ascend"]
      };

      if (column.sortable) {
        newColumn.onHeaderCell = () => {
          return {
            onClick: () => {
              const currentSortOrder = this.state.sortOrder;
              let nextSortOrder;
              if (currentSortOrder === 0) {
                nextSortOrder = -1;
              } else if (currentSortOrder === -1) {
                nextSortOrder = 1;
              } else {
                nextSortOrder = 0;
              }

              this.setState({ sortOrder: nextSortOrder }, () => {
                this.props.setSort(column.key, nextSortOrder);
              });
            }
          };
        };
        //newColumn.sorter = () => 0;
        newColumn.sortOrder = null;
      }
      if (column.render) {
        newColumn.render = column.render;
      }
      // console.log("newColumn : ", newColumn);
      return newColumn;
    });

    return (
      <div class="p-content-page-center p-content-page-center-full">
        <div class="p-content-page-center-header">
          <h2 class="p-content-page-center-header-title">Liste des modèles</h2>
          <div class="p-content-page-center-header-buttons">
            <div class="p-content-page-center-header-buttons-item">
              <ImportModele
                ref={this.importForm}
                {...this.props}
                onModalClosed={() => {
                  this.props.getNext(page);
                }}
              />
            </div>
          </div>
        </div>
        <div class="p-content-page-center-content">
          <List
            columns={columns}
            data={!_.isEmpty(modelsList) ? modelsList : []}
            page={page}
            pages={pages}
            defaultText="Aucun modèle trouvé."
            loading={modelsListLoading}
          />
          <div className="p-al-right p-mrg-ver">
            <Pagination page={page} pages={pages} pageSize={pageSize} nbItems={nbItems} getNext={getNext} />
          </div>
        </div>
      </div>
    );
  }
}

export default ModelesList;



// WEBPACK FOOTER //
// src/containers/admin/modeles/ModelesList.js